import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useModal } from '../../../hooks'
import { defaultPage } from '../../../hooks/useNavigation/constants'
import { EModalName } from '../../../types/enums'
import { trpc } from '../../../utils'
import { Button, Input } from '../../atoms'
import { InputPassword } from '../../molecules'
import { Lobby } from '..'
import type { LobbyFilterType } from '../LobbyFilter'
import {
  button,
  buttons,
  container,
  createGameButton,
  description,
  header,
  input,
  inputs,
  sectionBreaker,
} from './index.css'

export const ConnectToPrivateTable = (props: {
  onClickCreatePrivateTable: () => void
  onClickJoin: (table: { id: string; password: string | null }) => void
}) => {
  const { mutate, data } = trpc.table.getTable.useMutation()

  const { t } = useTranslation()
  const { openInfoModal } = useModal()
  const [tableCode, setTableCode] = useState('')
  const [tablePassword, setTablePassword] = useState('')
  const [filter, setFilter] = useState(defaultPage.options as LobbyFilterType)

  useEffect(() => {
    if (!data) {
      return
    }
    const { id, password } = data
    props.onClickJoin({ id, password })
  }, [data])

  const onClickConnect: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()
    mutate(
      {
        password: tablePassword,
        code: tableCode,
      },
      {
        onError(error, variables, context) {
          if (error.data?.code === 'NOT_FOUND') {
            openInfoModal(
              {
                text: t('modal.info.privateTableNotFound.text'),
                buttonText: t('modal.info.privateTableNotFound.confirm'),
              },
              {
                title: t('modal.info.privateTableNotFound.title'),
                name: EModalName.TABLE_NOT_FOUND,
              },
            )
          }
        },
      },
    )
  }

  return (
    <div className={container}>
      <form onSubmit={onClickConnect}>
        <h4 className={header}>
          {t('connectToPrivateGame.label.connectToPrivateGame')}
        </h4>
        <span className={description}>
          {t('connectToPrivateGame.label.enterCode')}
        </span>
        <div className={inputs}>
          <Input
            placeholder={t('connectToPrivateGame.placeholder.enterCode')}
            required={true}
            className={input}
            value={tableCode}
            onChange={(value) => setTableCode(value || '')}
          />
          <InputPassword
            placeholder={t('connectToPrivateGame.placeholder.password')}
            className={input}
            value={tablePassword}
            onChange={(value) => setTablePassword(value || '')}
          />
        </div>
        <div className={buttons}>
          <Button
            className={createGameButton}
            analytic={{
              name: 'create',
            }}
            onClick={props.onClickCreatePrivateTable}
          >
            {t('connectToPrivateGame.button.createGame')}
          </Button>
          <Button
            variant='primary'
            type='submit'
            className={button}
            analytic={{
              name: 'connect',
            }}
          >
            {t('connectToPrivateGame.button.connect')}
          </Button>
        </div>
      </form>

      <div className={sectionBreaker}></div>
      <h4 className={header}>{t('connectToPrivateGame.label.privateGames')}</h4>
      <Lobby
        type='PRIVATE'
        filter={filter}
        onClickSit={props.onClickJoin}
        onFilterUpdate={setFilter}
      />
    </div>
  )
}
